module.exports = __webpack_public_path__ + "static/media/canchas.a5a5a16f.jpg";